// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchUpsell-cls1___0f58f3db05b11b8a632{/*!*/}.SearchUpsell-cls2__dd4468c3ad28479b8384{text-transform:uppercase;letter-spacing:.5px;color:#999;margin-bottom:26px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SearchUpsell-cls1___0f58f3db05b11b8a632",
	"cls2": "SearchUpsell-cls2__dd4468c3ad28479b8384 SearchUpsell-cls1___0f58f3db05b11b8a632"
};
export default ___CSS_LOADER_EXPORT___;
